// extracted by mini-css-extract-plugin
module.exports = {"RateStars":"RateStars_RateStars__1u2if"};